module.exports = __webpack_public_path__ + "static/Raleway-Bold-f49f3d2d9df5013c9bfaab7e3d39ee57.ttf";